import I18n from 'i18n';
import Snack from '@beunity/design/lib/snackbar_extend.js';
import Turbolinks from 'turbolinks';
import TurboNativeAdapter from '@beunity/turbo_native_adapter';

const Mobile = TurboNativeAdapter;
const { IS_MOBILE } = Mobile;

function resolveRedirectUrl(url) {
  // eslint-disable-next-line compat/compat
  return fetch(url, {
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(r => r.json()).then(json => json.Location || json.location);
}

// function isImage(url) {
//   return /\.(png|jpg|jpeg|gif)/.test(url);
// }

function isPdf(url) {
  return /\.(pdf)/.test(url);
}

function extractFilenameFromUrl(url) {
  const decoded = decodeURI(url);
  const rfc5987Match = decoded.match(/filename\*(?:%3D|=)[^;]*UTF-8''([^&]*)(?:&|$)/);
  if (rfc5987Match && rfc5987Match[1]) {
    return decodeURIComponent(rfc5987Match[1]);
  }
  const pathMatch = decoded.match(/\/([^/?#]+)(?:\?|#|$)/);
  return pathMatch ? decodeURIComponent(pathMatch[1]) : 'download_file';
}

// eslint-disable-next-line import/prefer-default-export
export function downloadFileOld(e) {
  if (IS_MOBILE) { e.preventDefault(); }

  const { currentTarget } = e;
  const isDownloadLink = currentTarget.href.includes('/download/');

  const getUrl = resolveRedirectUrl(currentTarget.href);

  if (isDownloadLink) {
    getUrl.then((location) => {
      IS_MOBILE && isPdf(location)
        ? Turbolinks.visit(location)
        : Mobile.downloadImage(location);
    });
  } else {
    Mobile.downloadImage(e.currentTarget.href);
  }

  Snack({ text: I18n.t('snack.downloading') });
}

export function downloadFileNew(e) {
  if (!IS_MOBILE) {
    Snack({ text: I18n.t('snack.downloading') });
    return;
  }

  e.preventDefault();

  resolveRedirectUrl(e.currentTarget.href).then((location) => {
    const filename = extractFilenameFromUrl(location);
    Mobile.preview(location, filename);
  });
}

export const downloadFile = Mobile.preview ? downloadFileNew : downloadFileOld;

$(document).on('click', '[href*="/download/"], .js-download-image, .iv-fullscreen-download', downloadFile);
